import { jsx as o } from "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as s } from "../../../context/theme/hooks.js";
import u from "../../../styles/colors/surfaces/useForegroundVariantColor.js";
import "../../layout/Stack/Stack.js";
import f from "../../layout/Box/Box.js";
import c from "../../layout/Inline/Inline.js";
import "../../layout/Center/Center.js";
import "react";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import "../../../index-CZ8zjHGv.js";
import g from "./ToggleButtonOption.js";
function M({
  options: r,
  selectedValue: t,
  onChange: e,
  width: m = "fit-content"
}) {
  const i = s(), n = u("1"), l = r.map(() => "auto");
  return /* @__PURE__ */ o(
    f,
    {
      dataTest: "ToggleButton",
      width: m,
      borderRadius: "small",
      padding: "xxsmall",
      backgroundColor: n,
      borderStyle: "solid",
      borderWidth: "xxxsmall",
      borderColor: i["neutral-xLow-content"],
      children: /* @__PURE__ */ o(c, { space: "small", flexValues: l, children: r.map(({ label: a, value: p }, d) => /* @__PURE__ */ o(
        g,
        {
          selectedValue: t,
          onChange: e,
          label: a,
          value: p
        },
        d
      )) })
    }
  );
}
export {
  M as default
};
